import React, { useEffect }  from "react";
import { useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';

const ConditionsPage = (props) => {
  const location = useLocation();
  const { isError, data, error } = useQuery(['conditions'], () => fetchConditions(), {    
    enabled: !!props.token, // query inattiva finchè il token non è valido (non necessario)
    staleTime: 60 * 60 * 24 * 1000, // cache stale time impostato a 24 ore
  });

  async function fetchConditions() {
    try {
      var myHeaders = new Headers();
      //console.log("fetchMenuData() - with token: " + Token.access_token);
      myHeaders.append("Authorization", "Bearer " + props.token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/staticPage/Condizioni",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const payload = await response.text();
      console.log("fetchConditions() OK");
      //console.log(payload);
      return payload;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      throw new Error(error.message);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  function setHtml() {
      return { __html: data };
  }
   
  if (!data) {
    //console.log(props);
    if (isError && error !== null) 
      return <p>{error.message}</p>;
    else 
      return (
        <div className="spinner" >
        <img src="/images/waiting.gif" alt="loading..." />
      </div>
    
      )
  } 

  return (
      <div className="contenitore_01">
        <div className="contenuto_statico">
          <h1 className="titolo_pagina">Condizioni di vendita</h1>
          <div dangerouslySetInnerHTML={setHtml()} />
        </div>
      </div>
  );
};

export default ConditionsPage;